import { io } from 'socket.io-client';
import { getToken } from './api';

let socket = null;

export const connectSocket = () => {
  const token = getToken();
  if (!token) {
    console.error('No token found, cannot connect socket');
    return null;
  }
  // Reuse existing socket if already initialized
  if (socket) return socket;

  socket = io(process.env.REACT_APP_SOCKET_URL, {
    auth: { token },
    transports: ['websocket'],
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 2000,
    reconnectionDelayMax: 5000,
  });

  socket.on('connect', () => {
    console.log('Socket connected:', socket.id);
  });
  socket.on('connect_error', (err) => {
    console.error('Socket connection error:', err?.message || err);
  });
  socket.on('disconnect', (reason) => {
    console.warn('Socket disconnected:', reason);
  });

  return socket;
};

export const getSocket = () => socket;
